"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckReport = exports.HealthCheckError = exports.CheckCompletionResult = exports.CheckCompletionData = exports.JobStatus = exports.CheckCompletionPayload = exports.CompletionTrigger = exports.JobMessagePayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const CoreJob = __importStar(require("../../../../job"));
const JobEngine = __importStar(require("../../../../job-engine"));
const field_1 = require("../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.PubSub.Job.Schema';
exports.JobMessagePayload = effect_1.Schema.Struct({
    jobId: (0, field_1.nonEmpty)('Id of the job to load or run'),
    command: effect_1.Schema.propertySignature(CoreJob.Command).annotations({
        description: 'What to do with the job: load prepares it, run executes its next step',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.JobMessagePayload`,
    description: 'Scheduler callback that asks the API to load or run a job',
});
exports.CompletionTrigger = effect_1.Schema.Literal('device-completion', 'manual', 'health-check').annotations({
    identifier: `${exports.NAMESPACE}.CompletionTrigger`,
    description: 'What asked for the check',
});
exports.CheckCompletionPayload = effect_1.Schema.Struct({
    jobId: (0, field_1.nonEmpty)('Id of the job whose child tasks are checked'),
    deviceId: (0, field_1.nonEmpty)('Serial number of the device that finished its task'),
    taskId: (0, field_1.optionalString)('Id of the finished task. Only written to the log'),
    triggeredBy: effect_1.Schema.propertySignature(exports.CompletionTrigger).annotations({
        description: 'What asked for the check',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CheckCompletionPayload`,
    description: 'Asks the API to close a job once all its child tasks have succeeded',
});
exports.JobStatus = effect_1.Schema.Enums(JobEngine.JobStatus).annotations({
    identifier: `${exports.NAMESPACE}.JobStatus`,
    description: 'Job state',
});
exports.CheckCompletionData = effect_1.Schema.Struct({
    jobId: (0, field_1.nonEmpty)('Id of the checked job'),
    totalTasks: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({
        description: 'Number of child tasks of the job. 0 when the job was already completed',
    }),
    completedTasks: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({
        description: 'Child tasks in the completed state, delivered ones not counted. 0 when the job was already completed',
    }),
    parentJobUpdated: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'True when this call moved the job to completed',
    }),
    parentJobStatus: effect_1.Schema.propertySignature(exports.JobStatus).annotations({
        description: 'Status of the job after the check',
    }),
    alreadyCompleted: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'True when the job was already completed before the check',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CheckCompletionData`,
    description: 'Outcome of the completion check',
});
exports.CheckCompletionResult = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(true),
    data: effect_1.Schema.Struct({
        success: effect_1.Schema.Literal(true),
        data: exports.CheckCompletionData,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CheckCompletionResult`,
    description: 'Completion check outcome, wrapped in the success envelope twice',
});
exports.HealthCheckError = effect_1.Schema.Struct({
    jobId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Job whose check threw. Left out for a scheduling error',
    }),
    error: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Message of the error' }),
    type: effect_1.Schema.optionalWith(effect_1.Schema.Literal('scheduling_error'), { exact: true }).annotations({
        description: 'Set when the next check could not be queued',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.HealthCheckError`,
    description: 'An error the check caught and went on after',
});
const count = (description) => effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({ description });
exports.HealthCheckReport = effect_1.Schema.Struct({
    timestamp: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'ISO 8601 time the check started',
    }),
    totalRunningJobs: count('Jobs in the running state'),
    totalRunningExportJobs: count('CSV export jobs in the running state'),
    staleExportJobsFailed: count('Stale export jobs this check moved to failed'),
    stalledJobsRecovered: count('Stalled jobs this check recovered'),
    healthyJobs: count('Running jobs that were not stalled'),
    errors: effect_1.Schema.propertySignature(effect_1.Schema.Array(exports.HealthCheckError)).annotations({
        description: 'Errors the check caught. Empty when nothing failed',
    }),
    nextHealthCheckScheduled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'True when the next check was queued, which happens while jobs still run',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.HealthCheckReport`,
    description: 'Report of the running jobs health check',
});
//# sourceMappingURL=schema.js.map